import { getPersistConfig } from '@ms/yammer-data/dist/persistedState';

import { YammerEmbedState } from '../../state/types';

export const persistConfig = getPersistConfig<YammerEmbedState>({
  key: 'embed',
  allowlist: ['ecsConfig', 'ecsExperiments', 'ecsFeatureRollouts'],
});
